<div class="layout_page w-100 h-100 scrollbar" id="scrollbar" :class="{'layout_Sup': layoutSup}" :theme="layoutTheme">
    <div class="layout_shell" :class="{ 'layout_shell--sidebar-collapsed': sidebarCollapsed }">
        <aside class="layout_sidebar" :class="{ 'layout_sidebar--open': collapsed, 'layout_sidebar--collapsed': sidebarCollapsed }">
            <div class="layout_sidebar_brand">
                <router-link class="layout_sidebar_brand_link" to="/Dashboard" @click.native="closeMobileMenu">
                    <img :src="require( `../img/${logoLayoutSrc}.svg`)" class="layout_sidebar_logo"
                        :class="{ 'layout_sidebar_logo--rail': sidebarCollapsed }" alt="" />
                </router-link>
            </div>
            <ul class="layout_sidebar_nav">
                <li v-for="item in sidebarNavItems" :key="item.key" v-if="item.show" class="layout_sidebar_item"
                    :class="{ 'has-active-child': item.isDropdown && isDropdownParentActive(item) }">
                    <router-link v-if="!item.isDropdown" class="layout_sidebar_link" :to="item.route" exact-active-class="active-link"
                        :class="{ 'active-link': $route.path === item.route }" :title="item.text" @click.native="closeMobileMenu">
                        <i class="layout_sidebar_icon" :class="getMenuIcon(item.key)"></i>
                        <span class="layout_sidebar_label">{{ item.text }}</span>
                    </router-link>
                    <template v-else-if="item.isDropdown && item.route">
                        <div class="layout_sidebar_parent" :class="{ 'show': isDropdownOpen(item.key) }">
                            <router-link :to="item.route" class="layout_sidebar_link" :title="item.text"
                                @click.native="onParentNavClick(item, $event)">
                                <i class="layout_sidebar_icon" :class="getMenuIcon(item.key)"></i>
                                <span class="layout_sidebar_label">{{ item.text }}</span>
                            </router-link>
                            <span v-if="item.children && item.children.length > 0" class="layout_sidebar_toggle" @click.stop="openDropdown(item.key)">
                                <i class="fas fa-caret-down nav-dropdown-caret" :class="{ 'layout_sidebar_caret--open': isDropdownOpen(item.key) }"></i>
                            </span>
                        </div>
                        <ul v-if="item.children && item.children.length > 0" class="layout_sidebar_children" :class="{ 'show': isDropdownOpen(item.key) }">
                            <li v-for="child in item.children" :key="child.key" v-if="child.show">
                                <router-link :to="child.route" class="layout_sidebar_link layout_sidebar_link--child" exact-active-class="active-link"
                                    :title="child.text" @click.native="closeMobileMenu">
                                    <i class="layout_sidebar_icon layout_sidebar_icon--child" :class="getMenuIcon(child.key)"></i>
                                    <span class="layout_sidebar_label">{{ child.text }}</span>
                                </router-link>
                            </li>
                        </ul>
                    </template>
                    <template v-else-if="item.isDropdown && !item.route">
                        <a class="layout_sidebar_link layout_sidebar_parent-toggle" href="javascript:void(0);"
                            :title="item.text" @click.stop="onParentToggleClick(item)">
                            <span class="layout_sidebar_parent-toggle_main">
                                <i class="layout_sidebar_icon" :class="getMenuIcon(item.key)"></i>
                                <span class="layout_sidebar_label">{{ item.text }}</span>
                            </span>
                            <i class="fas fa-caret-down nav-dropdown-caret" :class="{ 'layout_sidebar_caret--open': isDropdownOpen(item.key) }"></i>
                        </a>
                        <ul v-if="item.children && item.children.length > 0" class="layout_sidebar_children" :class="{ 'show': isDropdownOpen(item.key) }">
                            <li v-for="child in item.children" :key="child.key" v-if="child.show">
                                <router-link :to="child.route" class="layout_sidebar_link layout_sidebar_link--child" exact-active-class="active-link"
                                    :title="child.text" @click.native="closeMobileMenu">
                                    <i class="layout_sidebar_icon layout_sidebar_icon--child" :class="getMenuIcon(child.key)"></i>
                                    <span class="layout_sidebar_label">{{ child.text }}</span>
                                </router-link>
                            </li>
                        </ul>
                    </template>
                </li>
            </ul>
            <div class="layout_sidebar_footer">
                <router-link v-if="showProviderProfileLink" class="layout_sidebar_link layout_sidebar_footer_link layout_sidebar_profile"
                    to="/Providers/EditProvider" exact-active-class="active-link" :title="$t('shared.myProfile')"
                    @click.native="closeMobileMenu">
                    <i class="layout_sidebar_icon" :class="getMenuIcon('MyProfile')"></i>
                    <span class="layout_sidebar_label">{{$t('shared.myProfile')}}</span>
                </router-link>
                <router-link v-if="showSidebarSlaLink" class="layout_sidebar_link layout_sidebar_footer_link layout_sidebar_sla"
                    to="/SLA" exact-active-class="active-link" :title="$t('shared.sla')"
                    @click.native="closeMobileMenu">
                    <i class="layout_sidebar_icon" :class="getMenuIcon('SLA')"></i>
                    <span class="layout_sidebar_label">{{$t('shared.sla')}}</span>
                </router-link>
                <a class="layout_sidebar_link layout_sidebar_footer_link layout_sidebar_logout" href="javascript:void(0);" :title="$t('shared.logOut')" @click="showLogOutDialog">
                    <i class="layout_sidebar_icon fas fa-sign-out-alt"></i>
                    <span class="layout_sidebar_label">{{$t('shared.logOut')}}</span>
                </a>
            </div>
            <button type="button" class="layout_sidebar_edge_toggle layout_sidebar_edge_toggle--docked" @click="toggleDesktopSidebar"
                :title="sidebarCollapsed ? $t('shared.showMenu') : $t('shared.hideMenu')"
                :aria-label="sidebarCollapsed ? $t('shared.showMenu') : $t('shared.hideMenu')">
                <i class="fas fa-chevron-right layout_sidebar_edge_icon"></i>
            </button>
        </aside>
        <div class="layout_sidebar_backdrop" :class="{ 'layout_sidebar_backdrop--visible': collapsed }" @click="closeMobileMenu"></div>
        <div class="layout_main">
            <nav class="layout_topbar navbar navbar-expand-lg navbar-light px-0">
                <button class="navbar-toggler layout_topbar_toggler" type="button" @click="collapse">
                    <span class="navbar-toggler-icon"></span>
                </button>
            </nav>
            <div class="layout_content" :class="{ 'has-page-title': !!currentPageTitle }">
                <div class="container">
                    <div class="layout_page_title" v-if="currentPageTitle">
                        <label class="header_text mb-0">{{ currentPageTitle }}</label>
                    </div>
                    <router-view v-on:childinit="onChildInit" />
                    <div class="layout_footer form-row justify-content-between align-items-center">
                        <div class="col-auto">
                            <a>
                                {{$t('shared.privacy')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <a>
                                {{$t('shared.termsOfUse')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <a>
                                {{$t('shared.copyRight')}} {{currentYear}}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="logOutDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.logOut')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideLogOutDialog"></i>
                    </div>
                </v-card-title>

                <v-card-text class="text-center">
                    <i class="fas fa-sign-out-alt"></i>
                    <p class="mt-3">
                        {{$t('shared.logOutText')}}
                    </p>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideLogOutDialog">
                                {{$t('shared.no')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="logOut">{{$t('shared.yes')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="loginDialog" persistent width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.reLogin')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideLoginDialog"></i>
                    </div>
                </v-card-title>

                <v-card-text v-if="logInForm">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <img :src="require('../img/User.svg')" />
                                    </span>
                                </div>
                                <input type="text" class="form-control border-left-0" v-model="userName"
                                       :placeholder="$t('loginPage.userName')" />
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><img :src="require('../img/Lock.svg')" /></span>
                                </div>
                                <input class="form-control border-right-0 border-left-0" v-model="password"
                                       v-bind:type="[showPassword ? 'text' : 'password']"
                                       maxlength="64"
                                       :placeholder="$t('loginPage.password')" />
                                <div class="input-group-append">
                                    <span class="input-group-text right">
                                        <i class="fas"
                                           :class="{ 'fa-eye-slash': showPassword, 'fa-eye': !showPassword }"
                                           @click="showPassword = !showPassword"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12" v-if="errorUserCertificate">
                            <div class="form-group">
                                <label class="red_text">{{$t('shared.errorUserCertificate')}}</label>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-text v-if="otpForm">
                    <label class="w-100 text-center text_body">
                        {{$t('loginPage.enterOtp')}} <br />
                        {{$t('loginPage.OtpReminingTime')}}: {{ countDown }}
                    </label>
                    <div class="row row_input pb-4">
                        <div class="col-md-12">
                            <div class="form-group">
                                <div class="input-group mb-3">
                                    <input type="text" class="form-control text-center" v-model="otp" />
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center" v-if="logInForm">
                        <div class="col-auto mx-3">
                            <a class="link_login" @click="hideLoginDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-primary mb-2" :disabled="!isValid"
                                    @click="login">
                                {{$t('loginPage.login')}}
                            </button>
                        </div>
                    </div>
                    <div class="form-row justify-content-end align-items-center" v-if="otpForm">
                        <div class="col-auto mx-3">
                            <button class="btn btn-primary mb-2" :disabled="isResendValid"
                                    @click="resendOtp">
                                {{$t('loginPage.resendOtp')}}
                            </button>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-primary mb-2" :disabled="!isResendValid"
                                    @click="verfiyOTP">
                                {{$t('loginPage.verfiyOTP')}}
                            </button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>
